const $document = $(document);

$document.ready(function () {
    scrollNavigation();

    $document.foundation()
        .on('load scroll', scrollNavigation);

    $('.next-button').click(function () {
        const id = $(this).attr('href');
        $('#collapsing-tabs').foundation('selectTab', id);
    });

    $('[data-rangeslider]').rangeslider({
        polyfill: false,
        onInit: function () {
            let position = this.$element.next().find('.rangeslider__handle').position().left;
            rangeSliderOutput(this.$element[0], position);
        },
        onSlide: function (position) {
            rangeSliderOutput(this.$element[0], position);
        }
    });

    const $pagesTotal = $('#pages_total');
    const $pages4c = $('#pages_4c');

    $pages4c.attr('max', $pagesTotal.val());

    $pagesTotal.on('change', function() {
        const value = $(this).val();
        $pages4c.attr('max', value);

        if (parseInt($pages4c.val()) >= parseInt(value)) {
            $pages4c.val(value).change();
            $pages4c.trigger('input');
        }
    });

    $pages4c.on('input', function() {
        const value = $(this).val();
        const totalValue = $pagesTotal.val();

        if (parseInt(value) > parseInt(totalValue)) {
            $('.validate-pages').parent().addClass('error');
            $('form').addClass('error-form');
            $('.next-button').each(function () {
                $(this).attr("disabled", true);
            });
        } else {
            $('.validate-pages').parent().removeClass('error');
            $('form').removeClass('error-form');

            $('.next-button').each(function () {
                $(this).attr("disabled", false);
            });
        }
    })


    $('input[data-toggle-element], select[data-toggle-element]')
        .toggleVisibility();

    /**
     * Return to Tab3 after Validation failed
     */
    var $target = window.location.hash

    if ($target) {
        $($target + '-label').click()
    }

    /**
     * Two Way Binding pages_total pages4c_total
     */

    var inputPagesTotal = $('#pages_total')
    var inputPages4c = $('#pages_4c')

    var inputHardcoverPagesTotal = $('#hardcover-pages_total')
    var inputHardcoverPages4c = $('#hardcover-pages_4c')

    inputPagesTotal.on('input', function () {
        var $input = $(this).val()
        inputHardcoverPagesTotal.val($input)
    })

    inputPages4c.on('input', function () {
        var $input = $(this).val()
        inputHardcoverPages4c.val($input)
    })

    inputHardcoverPagesTotal.on('input', function () {
        var $input = $(this).val()
        inputPagesTotal.val($input)
    })

    inputHardcoverPages4c.on('input', function () {
        var $input = $(this).val()
        inputPages4c.val($input)
        inputPages4c.trigger('input');
    })


    $(document).on('click', '.info-button', function () {
        var $target = $(this).data('toggle-target')

        if ($(this).hasClass('open')) {
            $('.accordion.info').foundation('up', $($target));
            $('.info-button').each(function () {
                $(this).removeClass('open')
            });
        } else {
            $('.info-button').each(function () {
                $(this).removeClass('open')
            });
            $('.accordion.info').foundation('down', $($target));
            $(this).addClass('open');
        }
    });

    $(document).on('click', '.address-accordion-trigger', function () {
        var $target = $(this).data('toggle-target')

        if ($(this).hasClass('open')) {
            $('.accordion.info').foundation('up', $($target));
            $('.address-accordion-trigger').each(function () {
                $(this).removeClass('open')
            });
        } else {
            $('.address-accordion-trigger').each(function () {
                $(this).removeClass('open')
            });
            $('.accordion.info').foundation('down', $($target));
            $(this).addClass('open');
        }
    })
});

/**
 *
 * @param element
 * @param position
 */
function rangeSliderOutput(element, position) {
    const value = element.value;
    const output = $(element).siblings('.output');

    output.css('left', position).html(value + ' Seiten');
}

/**
 *
 */
function scrollNavigation() {
    const $body = $('body');
    const scrollTop = $(this).scrollTop();
    const $pageNavigation = $('.page-navigation');
    const navHeight = $pageNavigation.outerHeight();

    if (!$body.hasClass('page-scrolled') && scrollTop >= navHeight) {
        $body.addClass('page-scrolled');
    }

    if ($body.hasClass('page-scrolled') && scrollTop < navHeight) {
        $body.removeClass('page-scrolled');
    }
}

/**
 *
 */
$('[data-target]').each(function () {
    $(this).on('load change', function () {
        const target = $(this).data('target');
        let value = $(this).val();
        $(target).text(value)
    }).triggerHandler('load');
});

$(document).on('click', '.set-extended', function() {
    $('#form-extended').val('true');
})


/*
 *
 */

$('#cover_id').bind('load change', function () {
    let coverValue = $(this).val()
    const $hardCoverGroup = $('#hardcover-execution optgroup[data-label]')
    const $softCoverGroup = $('#execution optgroup[data-label]')

    if (coverValue.includes('Hardcover')) {
        $hardCoverGroup.attr("label", coverValue)
    } else if (coverValue.includes('Softcover')) {
        $softCoverGroup.attr("label", coverValue)
    }

}).triggerHandler('load');
